import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {

    static targets = ["hm0_output"];

    connect() {
        console.log("Entreprise JS en cours ...");
        MicroModal.init();
        super.connect();
        //has many load
        //contacts

        if (
            $("#partial-contact-content").length &&
            $("#partial-contact-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_contact(), 300);
        }
        //missions
        if (
            $("#partial-mission-content").length &&
            $("#partial-mission-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_mission(), 300);
        }
        //bons_de_commande
        if (
            $("#partial-bons-de-commande-content").length &&
            $("#partial-bons-de-commande-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_bons_de_commande(), 300);
        }
        //contrat
        if (
            $("#partial-contrat-content").length &&
            $("#partial-contrat-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_contrat(), 300);
        }
        //document
        if (
            $("#partial-document-content").length &&
            $("#partial-document-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_document(), 300);
        }
        //facture
        if (
            $("#partial-facture-content").length &&
            $("#partial-facture-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_facture(), 300);
        }
        //factures_sous_traitant
        if (
            $("#partial-facture-sous-traitant-content").length &&
            $("#partial-facture-sous-traitant-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_facture_sous_traitant(), 300);
        }
        //entite
        if (
            $("#partial-entite-content").length &&
            $("#partial-entite-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_entite(), 300);
        }
        //mesures_de_satisfaction
        if (
            $("#partial-mesures-de-satisfaction-content").length &&
            $("#partial-mesures-de-satisfaction-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_mesure_de_satisfaction(), 300);
        }
        //achat_sous_traitant
        if (
            $("#partial-achat-sous-traitant-content").length &&
            $("#partial-achat-sous-traitant-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_achat_sous_traitant(), 300);
        }
        //piste
        if (
            $("#partial-piste-content").length &&
            $("#partial-piste-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_piste(), 300);
        }
        //client/fournisseurs
        if (
            $("#partial-client-content").length &&
            $("#partial-client-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_client(), 300);
        }
        //facture fournisseurs
        if (
            $("#partial-fournisseur-content").length &&
            $("#partial-fournisseur-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_fournisseur(), 300);
        }
        if (
            $("#partial-doublons-content").length &&
            $("#partial-doublons-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_doublons(), 300);
        }

        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            if ($("#activate_em").length) {
                this.show_edition_multiple();
            }
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
        }
    }

    entreprise_hm_ajax() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm?entreprise_id=" +
                this.entreprise_id +
                "?parent_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-content").html("");
                    $("#partial-content").html(text);
                })
            );
        }
    }

    //contact
    entreprise_hm_ajax_contact() {
        if (this.current_app && this.entreprise_id) {
            if (
                $("#partial-contact-content").length &&
                $("#partial-contact-content").text().trim() == "Chargement en cours ..."
            ) {
                let url =
                    window.location.origin +
                    "/" +
                    this.current_app +
                    "/entreprises/show_ajax_for_hm_contact?entreprise_id=" +
                    this.entreprise_id +
                    "&vr2=1";
                fetch(url).then((response) =>
                    response.text().then(function (text) {
                        $("#partial-contact-content").html("");
                        $("#partial-contact-content").html(text);
                    })
                );
            }
        }
    }

    //opportunite
    entreprise_hm_ajax_mission() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_mission?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-mission-content").html("");
                    $("#partial-mission-content").html(text);
                })
            );
        }
    }

    //bons de commande
    entreprise_hm_ajax_bons_de_commande() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_bons_de_commandes?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-bons-de-commande-content").html("");
                    $("#partial-bons-de-commande-content").html(text);
                })
            );
        }
    }

    //facture
    entreprise_hm_ajax_facture() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_factures?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-facture-content").html("");
                    $("#partial-facture-content").html(text);
                })
            );
        }
    }

    //entite
    entreprise_hm_ajax_entite() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_entites?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-entite-content").html("");
                    $("#partial-entite-content").html(text);
                })
            );
        }
    }

    //document
    entreprise_hm_ajax_document() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_documents?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-document-content").html("");
                    $("#partial-document-content").html(text);
                })
            );
        }
    }

    //contrat
    entreprise_hm_ajax_contrat() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_contrats?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-contrat-content").html("");
                    $("#partial-contrat-content").html(text);
                })
            );
        }
    }

    //factures-sous-traitant
    entreprise_hm_ajax_facture_sous_traitant() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_factures_sous_traitants?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-facture-sous-traitant-content").html("");
                    $("#partial-facture-sous-traitant-content").html(text);
                })
            );
        }
    }

    //mesures-de-satisfaction
    entreprise_hm_ajax_mesure_de_satisfaction() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_mesures_de_satisfactions?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-mesures-de-satisfaction-content").html("");
                    $("#partial-mesures-de-satisfaction-content").html(text);
                })
            );
        }
    }

    //achat-sous-traitant
    entreprise_hm_ajax_achat_sous_traitant() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_achats_soustraitants?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-achat-sous-traitant-content").html("");
                    $("#partial-achat-sous-traitant-content").html(text);
                })
            );
        }
    }

    //piste
    entreprise_hm_ajax_piste() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_pistes?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-piste-content").html("");
                    $("#partial-piste-content").html(text);
                })
            );
        }
    }

    //client/fournisseur
    entreprise_hm_ajax_client() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_contrats?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-client-content").html("");
                    $("#partial-client-content").html(text);
                })
            );
        }
    }
    entreprise_hm_ajax_fournisseur(){
     if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_fournisseurs?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-fournisseur-content").html("");
                    $("#partial-fournisseur-content").html(text);
                })
            );
        }   
    }
    entreprise_hm_ajax_doublons(){
     if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_doublons?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-doublons-content").html("");
                    $("#partial-doublons-content").html(text);
                })
            );
        }   
    }
    show_edition_multiple() {
        if (this.current_app && this.params) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_edition_multiple?filtrage=" +
                this.params +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#edition_multiple").html("");
                    $("#edition_multiple").html(text);
                    MicroModal.init();
                })
            );
        }
    }

    // Fonction pour ajouter la classe  fx-input-date-sidbar-menu aux champs de type date utulisant flatpickr

    get params() {
        return this.data.get("params");
    }

    get entreprise_ids() {
        return this.data.get("entrepriseids");
    }

    get entreprise_id() {
        return this.data.get("entrepriseid");
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
